<template>
    <b-row>
      <b-col cols="7" class="ml-auto">
        <b-input-group size="sm">
          <b-form-input
            size="sm"
            placeholder="Find items to add/remove from want list..."
            v-model="searchString"
            @keyup.enter="search"
          ></b-form-input>
          <b-input-group-append>
            <b-button
              v-if="!searching"
              @click="search"
              size="sm"
              variant="primary"
              :disabled="searching"
              class="d-flex"
            >
              <span>Search</span>

            </b-button>
            <b-spinner
            v-if="searching"
            class="ml-2 align-self-center"
            variant="primary"
            small
            ></b-spinner>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-modal centered scrollable size="md" hide-footer v-model="showSearchResults" ref="searchResultsModal" title="Search Results" @hide="discardModal">
        <h4 v-if="searchResults && searchResults.length < 1">No results</h4>
      <div v-else v-for="(item, index) in searchResults" :key="index">
        <b-row>
            <b-col>Item: {{ item.itemId }}</b-col>
        </b-row>
        <p class="mb-0" v-if="item.release"><strong>{{ artist(item) }}</strong></p>
        <p class="mb-0" v-if="item.release"><strong>{{ title(item) }}</strong></p>
        <p class="mb-0" v-if="item.release && item.release.label">{{ item.release.label.name }} {{ item.release.label.catalogNo }}</p>
        <p class="mb-0" v-if="item.release">{{ format(item.release.media) }}</p>
        <b-button
          class="mt-2"
          v-if="!isInWantList(item.itemId)"
          @click="addToWants(item.itemId)"
          variant="primary"
          size="sm"
        >
          Add to Wants
        </b-button>
        <b-button
          class="mt-2"
          v-else
          @click="removeFromWants(item.itemId)"
          size="sm"
        >
          Remove from Wants
        </b-button>
        <hr>
      </div>
    </b-modal>
    </b-row>
  </template>
  
  <script>
  import inventoryApi from "../../api/inventory";
  import OrderItemMixin from "../../builders/orderItem";
  
  export default {
    name: "WantListItemSearch",
    mixins: [inventoryApi, OrderItemMixin],
    props: [ "wantList" ],
    data() {
      return {
        searchString: "",
        searching: false,
        searchResults: null,
        selectedItems: [],
        showSearchResults: false
      }
    },
    methods: {
      async search() {
        try {
          this.searching = true;
  
          // Call your API method to search and add items to the want list
          const items = await this.searchItems({ q: this.searchString });
          // Handle the response or update your component's state as needed
          this.searchResults = items.docs;
          this.showSearchResults = true;
        } catch (error) {
          console.error("Error searching for items:", error);
          // Handle errors as needed
        } finally {
          this.searching = false;
        }
      },
      addToWants(itemId) {
        this.$emit("addToWants", [itemId]);
      },
      removeFromWants(itemId) {
        this.$emit("removeFromWants", [itemId]);
      },
      discardModal() {
        this.$refs.searchResultsModal.hide();
        this.searchResults = null;
      },
      isInWantList(itemId) {
        return this.wantList && this.wantList.includes(itemId);
      },
    },
  };
  </script>
  